import { useEffect } from 'react';
import { UseInfiniteQueryResult } from '@tanstack/react-query';
import { useInView } from 'react-intersection-observer';

import { Button, Text } from 'components';
import { Spinner } from 'components/Icon';

export type LoadMoreProps = {
  query: UseInfiniteQueryResult;
  autoFetch?: boolean;
};

const LoadMore = ({ query, autoFetch = false }: LoadMoreProps) => {
  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView && autoFetch) {
      query.fetchNextPage();
    }
  }, [inView, autoFetch]);

  if (query.isFetching && query.isFetchingNextPage) {
    return (
      <div className="text-center py-42">
        <Spinner />
      </div>
    );
  }

  if (query.hasNextPage) {
    return (
      <div ref={ref} className="py-24 d-flex justify-center">
        <Button onClick={() => query.fetchNextPage()}>Load More</Button>
      </div>
    );
  }

  if (query.data && query.data?.pages.length > 1) {
    return (
      <Text size="h4" className="text-center py-48">
        You reached the end
      </Text>
    );
  }

  return null;
};

export default LoadMore;
